import styled, { css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IAdProductSectionProps {
  $bgColor?: string;
  $textColor?: string;
}

export const AdProductSection = styled.div<IAdProductSectionProps>`
  background: #fff;
  padding: 32px 0;

  ${({ $bgColor, $textColor }) =>
    $bgColor &&
    css`
      background: ${$bgColor};

      .content-title,
      .tag {
        color: ${$textColor};
      }

      .tag.tag-soldout {
        background: rgba(172, 172, 172, 0.15);
        color: #000;
      }
    `}

  &.black {
    background: #000;

    .content-title {
      color: #fff;
    }

    .tag {
      color: #e2e2e2;
      border-color: #555;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('32 0')};
  }
`;

export const Title = styled.div`
  ${mixin.flex({ justify: 'space-between', align: 'flex-end' })};
  padding: 0 20px;
  margin-bottom: 16px;
  gap: 0 16px;

  .tag {
    padding: 2px 4px;
    border: 1px solid #e2e2e2;
    flex-shrink: 0;
    margin-bottom: 6.5px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('0 20')};
    margin-bottom: ${mixin.pxToVw('16')};

    .tag {
      padding: ${mixin.pxToVw('2 4')};
    }
  }
`;
